import { render, staticRenderFns } from "./AMeasuresCreationWidget.vue?vue&type=template&id=c7f96936&scoped=true&"
import script from "./AMeasuresCreationWidget.vue?vue&type=script&lang=ts&"
export * from "./AMeasuresCreationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f96936",
  null
  
)

export default component.exports